import { z } from "zod";

export const PHOTO_ROULETTE_NOTIFICATION_TYPE = "photo_roulette_invite" as const;

export const photoRouletteInviteDataSchema = z.object({
	type: z.literal(PHOTO_ROULETTE_NOTIFICATION_TYPE),
	group_id: z.string(),
	game_id: z.string(),
	host_name: z.string(),
});

export type PhotoRouletteInviteData = z.infer<typeof photoRouletteInviteDataSchema>;

const PHOTO_ROULETTE_RESOURCE_SEPARATOR = ":";

export const buildPhotoRouletteResourceId = (groupId: string, gameId: string): string =>
	`${groupId}${PHOTO_ROULETTE_RESOURCE_SEPARATOR}${gameId}`;

export const photoRouletteResourceIdSchema = z.string().transform((raw, ctx) => {
	const [groupId, gameId, ...rest] = raw.split(PHOTO_ROULETTE_RESOURCE_SEPARATOR);
	if (!groupId || !gameId || rest.length > 0) {
		ctx.addIssue({ code: z.ZodIssueCode.custom, message: "invalid_photo_roulette_resource_id" });
		return z.NEVER;
	}
	return { group_id: groupId, game_id: gameId };
});

export type PhotoRouletteResourceId = z.infer<typeof photoRouletteResourceIdSchema>;
